import { render, staticRenderFns } from "./RankingConf.vue?vue&type=template&id=093ac79f"
import script from "./RankingConf.vue?vue&type=script&lang=js"
export * from "./RankingConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports